import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Instructions from './Instructions';
import StartTestVerify from './StartTestVerify';

/**
 * Entry gate for /instructions (the test link target).
 *
 * - Authenticated candidate  → the real Instructions page (unchanged flow).
 * - Logged-out + ?test_id=…   → passwordless "verify email → start" card.
 * - Logged-out, no test_id    → normal login redirect (prior behavior).
 *
 * This is purely additive: it replaces the generic UserPrivateRoute wrapper on
 * THIS route only, preserving its redirect for the no-test_id case while adding
 * the verify-to-start path for invited candidates who don't have a session yet.
 */
export default function TestEntryGate() {
  const { isUserAuthenticated } = useAuth();

  let storedAuth = false;
  try {
    storedAuth = JSON.parse(localStorage.getItem('isUserAuthenticated')) || false;
  } catch (_) {
    storedAuth = false;
  }
  const authed = Boolean(isUserAuthenticated || storedAuth);

  const testId = new URLSearchParams(useLocation().search).get('test_id');

  if (authed) return <Instructions />;
  if (testId) return <StartTestVerify testId={testId} />;
  return <Navigate to="/login_user" />;
}
